import React from "react";
import { FTFlex } from "../flex";

export default function MobileMainSkeleton() {
  return (
    <FTFlex gap={16} direction="column" style={{ height: "100%", padding: 16 }}>
      <div
        className="skeleton_loading"
        style={{ flex: 1, width: "100%" }}
      ></div>
      <div
        className="skeleton_loading"
        style={{ height: 56, width: "100%" }}
      ></div>
    </FTFlex>
  );
}
